const routes = [
    {
        path: "/ie/reports",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "iereport_index"
        }
    }
];

export default routes;
